<template>
  <div class="detail-view">
    <div
      class="kiwi-form-group form-group"
      :class="
        !formData.user_full_name
          ? ''
          : formData.user_full_name !== null
          ? 'kiwi-form-success'
          : ''
      "
    >
      <label for="" class="kiwi-form-label"
        >Full Name <span class="kiwi-required kiwi-text-error">*</span></label
      >
      <v-text-field
        variant="outlined"
        v-model="formData.user_full_name"
        class="kiwi-form-input kiwi-radius-4"
        placeholder="Full Name"
        :rules="[handleErrors.rules.fullname]"
      ></v-text-field>
    </div>
    <v-row>
      <v-col cols="12" md="6">
        <div
          class="kiwi-form-group form-group"
          :class="
            !formData.country
              ? ''
              : formData.country !== null
              ? 'kiwi-form-success'
              : ''
          "
        >
          <label for="" class="kiwi-form-label"
            >Where are you from?
            <span class="kiwi-required kiwi-text-error">*</span></label
          >
          <v-autocomplete
            :items="countries"
            item-value="name"
            item-title="name"
            variant="outlined"
            v-model="formData.country"
            class="kiwi-form-input kiwi-radius-4"
            @update:modelValue="countryUpdate"
            :rules="[handleErrors.rules.required]"
          ></v-autocomplete>
          <span
            class="form-msg d-block mt-2"
            v-if="
              errorMessage.country ||
              (errorMessage.storemsg && errorMessage.storemsg.country)
            "
          >
            <span class="kiwi-text-error d-block" v-if="errorMessage.country">{{
              errorMessage.country
            }}</span>
            <span
              class="kiwi-text-error d-block"
              v-if="errorMessage.storemsg && errorMessage.storemsg.country"
              >{{ errorMessage.storemsg.country[0] }}</span
            >
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        
        <div
          class="kiwi-form-group form-group"
          :class="
            !telError && telError !== undefined
              ? 'kiwi-form-error'
              : formData.phone_number !== null
              ? 'kiwi-form-success'
              : ''
          "
        >
          <label for="" class="kiwi-form-label"
            >Phone Number
            <span class="kiwi-required kiwi-text-error">*</span></label
          >
          <vue-tel-input
            v-model="formData.phone_number"
            styleClasses="kiwi-form-input kiwi-radius-4"
            :dropdownOptions="dropdownOptions"
            :defaultCountry="country_code"
            :key="country_code"
            @validate="fetchTelError"
            @country-changed="handleCountryChange"
          ></vue-tel-input>
          <!-- :defaultCountry="formData && formData.country ? 'AQ' : ''" -->
          <span class="form-msg d-block mt-2 mb-6">
            <span
              class="kiwi-text-error d-block"
              v-if="(!telError && telError !== undefined) || errorMessage.storemsg?.phone_number?.length > 0"
              >{{ handleErrors.rules.phone_number(formData.phone_number, formData.country) || errorMessage.storemsg.phone_number[0] }}</span
            >
          </span>
        </div>
      </v-col>
    </v-row>
    <div class="kiwi-form-group form-group">
      <label for="" class="kiwi-form-label">Exam Type <span class="kiwi-required kiwi-text-error">*</span></label>
      <v-select
        :items="streamList"
        item-title="name"
        item-value="id"
        variant="outlined"
        v-model="formData.stream"
        class="kiwi-form-input kiwi-radius-4"
        :placeholder="streamList[0]?.name"
        :rules="[handleErrors.rules.required]"
      ></v-select>
    </div>
    <div
      class="kiwi-form-group form-group"
      :class="
        !formData.referred_by_code
          ? ''
          : formData.referred_by_code !== null
          ? 'kiwi-form-success'
          : ''
      "
      v-if="institute.$hasFeature('referral')"
    >
      <label for="" class="kiwi-form-label">Referral Code </label>
      <v-text-field
        hide-details
        variant="outlined"
        v-model="formData.referred_by_code"
        class="kiwi-form-input kiwi-radius-4"
        placeholder="Enter Referral Code (Optional)"
        :rules="[errorMessage.storemsg?.referred_by_code]"
      ></v-text-field>
      <span
        class="form-msg d-block mt-2"
        v-if="
          errorMessage.referred_by_code ||
          (errorMessage.storemsg && errorMessage.storemsg.referred_by_code)
        "
      >
        <span
          class="kiwi-text-error d-block"
          v-if="errorMessage.referred_by_code"
          >{{ errorMessage.referred_by_code }}</span
        >
        <span
          class="kiwi-text-error d-block"
          v-if="errorMessage.storemsg && errorMessage.storemsg.referred_by_code"
          >{{ errorMessage.storemsg.referred_by_code[0] }}</span
        >
      </span>
    </div>
    <div class="kiwi-form-note kiwi-text-black mt-4 font-weight-medium kiwi-text-light-black-2">
      By clicking sign up you agree with our
      <router-link
        to="/terms-condition"
        target="_blank"
        class="kiwi-text-black-3 font-weight-semi-bold text-decoration-none"
        >Terms of Use</router-link
      >
      and
      <router-link
        to="/privacy"
        target="_blank"
        class="kiwi-text-black-3 font-weight-semi-bold text-decoration-none"
        >Privacy Policy</router-link
      >.
    </div>

    <div class="kiwi-form-btnwrap mt-6">
      <v-row>
        <v-col cols="12" md="6">
          <v-btn
            block
            class="kiwi-bg-white  text-none kiwi-text-black kiwi-button kiwi-radius-8 kiwi-fs-16 font-weight-semi-bold"
            size="x-large"
            variant="flat"
            style="border: 1px solid #dbe1e0"
            @click="backToInitial"
            >
            Back</v-btn
          >
        </v-col>
        <v-col cols="12" md="6" >
          <v-btn
          class="text-none text-uppercase mb-4 text-body-1 kiwi-bg-primary kiwi-text-white"
          size="x-large"
          variant="flat"
          block
          height="56"
          :disabled="
            !isValid ||
            isSubmitting ||
            !auth.formData.user_full_name ||
            !auth.formData.country ||
            !auth.formData.phone_number ||
            !telError && telError !== undefined
          "
          :class="
            !isValid ||
            isSubmitting ||
            !auth.formData.user_full_name ||
            !auth.formData.country ||
            !auth.formData.phone_number
              ? 'kiwi-button-disable kiwi-bg-disabled'
              : ''
          "
          @click="registerUser"
        >
          {{ !isSubmitting ? `Sign Up` : `Signing Up...` }}
        </v-btn>
        </v-col>
      </v-row>
     
      
    </div>
    <!-- <Prompt max-width="500" v-if="openEmailVerification">
      <div class="pa-4 d-flex">
        <img src="/assets/checkmark-circle-01 (1).svg" class="mr-2">
        <div class="kiwi-fs-14 font-weight-medium">Email verification link sent successfully. Please verify your email address.</div>
      </div>
    </Prompt> -->
  </div>
</template>

<script setup>
import { api, apiWithoutAuth } from "@/plugins/axios";
import { useValidation } from "@/composables/useValidation";
import {
  submittingProcess,
  resetSubmitFrom,
  isSubmitting,
} from "@/handler/multipleFormSubmitPreventer";
import countries from "@/handler/CountryCodes";
import { useKiwiFormValidationCheck } from "@/stores/kiwiFormValidation";
import { useRegisterStore } from "@/stores/registrationStore";
import Prompt from '@/components/Prompt/ConfirmAlert.vue'
import { storeToRefs } from "pinia";
import { ref, computed, onMounted , watch, defineEmits } from "vue";
import {
  signInWithGoogle,
  signInWithFacebook,
  AuthTokenService,
} from "@/handler/authService";
import { useRoute, useRouter } from "vue-router";
import { useConfirmer } from "@/stores/confirmer";
import { useCountryCode } from '@/composables/useCountryCode';
import { useInstituteStore } from '@/stores/institute/institute-store';
const institute = useInstituteStore()
const props = defineProps(['isSocial'])

const router = useRouter();
const auth = useRegisterStore();
const confirmer = useConfirmer();
const { register, socialRegister, sendEmailVerificationOtp } = auth;
const validation = useKiwiFormValidationCheck();
const handleErrors = useValidation();
const { formData, authState } = storeToRefs(auth);
const { openSnackbar, displayMsg } = storeToRefs(confirmer);
const { errorMessage } = storeToRefs(validation);
const { isValid } = storeToRefs(handleErrors)
const { getCountryCode } = useCountryCode()
const route = useRoute();

// const openEmailVerification = ref(false)
const emptyFieldState = ref(true);
auth.formData.user_full_name &&
auth.formData.country?.name &&
auth.formData.phone_number
  ? (emptyFieldState.value = false)
  : (emptyFieldState.value = true);

const inputUpdate = () => {
  validation.clearApiValidation();
  validation.detailFieldValidation();

  auth.formData.user_full_name &&
  auth.formData.country?.name &&
  auth.formData.phone_number
    ? (emptyFieldState.value = false)
    : (emptyFieldState.value = true);
};

const countryUpdate = () => {
  // formData.country_code = auth.formData.country.code
  const foundCountry = countries.find(country => country?.name === auth.formData.country);
  formData.value.country_code  = foundCountry.code

  // auth.asignCountryCode();
  auth.formData.user_full_name &&
  auth.formData.country?.name &&
  auth.formData.phone_number
    ? (emptyFieldState.value = false)
    : (emptyFieldState.value = true);
};

const streamList = ref([])

const country_code = computed(() => {
  return auth?.formData?.country_code;
});

const telError = ref(true);

const dropdownOptions = ref({
  showDialCodeInList: true,
  showDialCodeInSelection: true,
  showFlags: true,
});

const fetchTelError = (obj) => {
  if(obj && obj.formatted){
    if(handleErrors.rules.phone_number(obj) === true){
      telError.value = true;
    }else{
      telError.value = false;
    }
  }
};
const registerUser = async () =>{
  try{
    submittingProcess();
    if(props.isSocial){
      const response = await socialRegister(route.params.token)
      AuthTokenService.setTokens(response.access_token, response.refresh_token)
      confirmer.openSnackBar({type: "success" , msg: "Account Created successfully."});
      router.push({name: `dashboard`})

    }else{
      const response = await register();
      AuthTokenService.setVerifyToken(response.data.registration_token)
      AuthTokenService.setEmailCookie(response.data.user_data.email)
      const otp_res = await sendEmailVerificationOtp();
      confirmer.openSnackBar({type: "success", msg:otp_res.data.message});
      router.push({name: 'sendVerificationOTP'})
      // router.push({name: 'sendVerification'})
    }
    resetSubmitFrom();
    formData.value = {};
    // openEmailVerification.value = true;
    if(AuthTokenService.getCookie('REF_CODE')){
      AuthTokenService.removeCookie('REF_CODE')
    }

    // add new login cookie for tutorial
    AuthTokenService.setCookie('first_login', 1)

  }catch(error){
    validation.storeApiValidation(error)
    resetSubmitFrom();
    confirmer.openSnackBar({type: "error", msg:'Somthing Went Wrong Please try again'});
  }
};

const getVisitorCountry = async () => {
  try {
     const code = await getCountryCode();
     const foundCountry = countries.find(country => country.code === code);
     formData.value.country  = foundCountry.name
    countryUpdate();
  } catch (error) {}
};

const getCookie = (name) => {
  // Construct the name pattern to search for (name followed by '=')
  const nameEQ = name + "="
  const cookies = document.cookie.split(';')

  // Loop through cookies to find the one that matches the name
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i]
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length)
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length)
    }
  }
  return null
}

const getExamTypes = async () => {
  let url = 'user/streams/';
  const response = await apiWithoutAuth.get(url)
  streamList.value = response.data
}

  onMounted(() => {
    getVisitorCountry();
    formData.value.referred_by_code = getCookie('REF_CODE')
    getExamTypes()
  });

  watch(formData, (newVal) => {
    handleErrors.rules.fullname(newVal.user_full_name);
    handleErrors.rules.required(newVal.country);
    // handleErrors.rules.phone_number(newVal.phone_number, newVal.country);
  }, { deep: true })

  const emit = defineEmits (
    ['backToInitialView']
  )
  const backToInitial = () => {
    emit('backToInitialView');

  }

  //Country name as per the country code
  const handleCountryChange =(newCountry)=>{

    const dialCode = newCountry.iso2;


    const foundCountry = countries.find(function(country) {
      return country.code === dialCode;
    });
    formData.value.country= foundCountry.name;
  }
</script>

<style></style>
